<template>
    <div class="quote">
        <p><span>&ldquo;</span><slot></slot><span>&rdquo;</span></p>
    </div>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_citaat.scss
</style>

<script>
    export default {

    };
</script>
